import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import useTrans from '../../../hooks/useTrans'

const ProdottoPersonalizzazioneCard = ({
  prodotto,
  colore,
  quantitaMinimaPersonalizzabile,
  handleQuantita,
  onChangeInputQuantita,
  getError,
  getQuantita,
  staticQuantita,
  taglia,
  conLink,
  fromPdf,
}) => {
  const [massimaQuantitaPrenotabile, setMassimaQuantitaPrenotabile] = useState(0)
  const t = useTrans()
  useEffect(() => {
    if (!staticQuantita) {
      let disp = prodotto.disponibilita ? prodotto.disponibilita : 0
      setMassimaQuantitaPrenotabile(
        prodotto?.prossimi_arrivi
          ? prodotto.prossimi_arrivi
              .filter((item) => item.prenotabile)
              .reduce((current, quantita) => current + Number(quantita.disponibilita), 0) + disp
          : prodotto?.disponibilita
          ? prodotto.disponibilita
          : 0
      )
    }
  }, [])

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div className="p__personalizzazione__card">
        <img
          className="p__personalizzazione__card__image"
          src={
            fromPdf
              ? prodotto?.thumb_image?.url || prodotto?.main_image?.url
              : !staticQuantita
              ? prodotto?.immagini?.length > 0
                ? prodotto?.immagini[0]?.url
                : 'https://placehold.co/150x150/png'
              : prodotto?.main_image?.url
          }
        />

        <div className="p__personalizzazione__card__content">
          <div>
            {conLink ? (
              <Link href={prodotto?.url}>
                <a target="_blank">
                  <strong className="p__personalizzazione__card__content__title">
                    {prodotto?.codice}
                  </strong>
                </a>
              </Link>
            ) : (
              <strong className="p__personalizzazione__card__content__title">
                {prodotto?.codice}
              </strong>
            )}
            <p>
              {' '}
              <span className="p__personalizzazione__card__content__placeholder">
                {t('COLORE')}:{' '}
              </span>
              {colore?.nome}
            </p>
            {taglia && (
              <p>
                <span className="p__personalizzazione__card__content__placeholder">
                  {t('TAGLIA')}:{' '}
                </span>
                {taglia}
              </p>
            )}
          </div>
          {!staticQuantita ? (
            <div className="cell__quantità__wrapper__button">
              <button
                onClick={() =>
                 handleQuantita(
                    prodotto.id,
                    prodotto.codice,
                    prodotto.acquistabile_multipli,
                    massimaQuantitaPrenotabile,
                    prodotto.prossimi_arrivi,
                    prodotto.disponibilita,
                    'remove'
                  )
                }
              >
                -
              </button>
              <input
                onChange={(e) =>
                  e.target.value != 0 ? onChangeInputQuantita(
                    prodotto.id,
                    prodotto.codice,
                    parseInt(e.target.value),
                    massimaQuantitaPrenotabile,
                    prodotto.acquistabile_multipli,
                    prodotto.disponibilita,
                    prodotto.prossimi_arrivi
                  ) : undefined
                }
                value={getQuantita(prodotto.codice)}
                min={quantitaMinimaPersonalizzabile}
                type="number"
              ></input>
              <button
                onClick={() =>
                  handleQuantita(
                    prodotto.id,
                    prodotto.codice,
                    prodotto.acquistabile_multipli,
                    massimaQuantitaPrenotabile,
                    prodotto.prossimi_arrivi,
                    prodotto.disponibilita,
                    'add'
                  )
                }
              >
                +
              </button>
            </div>
          ) : (
            <div>
              <p>
                {t('Quantità')}: {staticQuantita}
              </p>
            </div>
          )}
        </div>
      </div>
      {getError && getError(prodotto?.codice) && (
        <p className="personalizzazione__card__error">{t('La quantità inserita non è corretta')}</p>
      )}
    </div>
  )
}

export default React.memo(ProdottoPersonalizzazioneCard)
